/* eslint-disable import/prefer-default-export */
import axios from 'axios'
import { personService } from '@hixme/api'
import { getEpsBaseUrl } from 'modules/api/eps-base-url'

export function getFamilyByEmployeeId(id) {
  return personService({
    route: `persons/${id}/family`,
  })
}

export function getPersonProviderById(id) {
  return axios
    .get(`${getEpsBaseUrl()}/core/persons/${id}/providers`)
    .then(({ data }) => data)
}
